export enum DotSize {
	Xs = "Xs",
	Sm = "Sm",
	Md = "Md",
}

export enum DotType {
	Success = "Success",
	Info = "Info",
	Error = "Error",
}
